import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_CREATE_NEW_CONTACT,
	STR_FILTER_BY_NAME_OR_PHONE,
	STR_NO_RECORD
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdInfoOutline, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdSearch } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import OneContact from '../ones/OneContact';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [filter, setFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
		])
		setReady(true);
	}



	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				className="container"
			>
			
				<div className="row">
					

					

					<div className="col-12">
						{
							(
								appContext.currentUserData && 
								JSON.parse(appContext.currentUserData.senderId).length > 0
							) ?
							JSON.parse(appContext.currentUserData.senderId).map((item, i) => {
								return (
									<h6
										style={{
											fontSize: "24px",
											padding: "15px",
											borderBottom: "2px solid var(--primaryColor)"
										}}
										key={i}
									>
										{item}
									</h6>
								)
							})
							:
							<h6
								style={{
									fontSize: "14px",
								}}
							>
								{STR_NO_RECORD[appContext.language]}
							</h6>
						}
					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}